import React from 'react';
import styles from './index.css';

class VerticalNav extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        return (
            <div className={styles.verticalNav}>
                <h2>关于我们</h2>
                <a href="#introduction">研究院简介</a>
                <a href="#framework">组织架构</a>
                <a href="#members">嘉宾寄语</a>
                {/* <a href="#video">视频短片</a> */}
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
VerticalNav.propTypes = {};

/**
 * 定义组件默认属性
 * */
VerticalNav.defaultProps = {};

export default VerticalNav;
